module.exports = __webpack_public_path__ + "static/magda_stepien@2x-058f3a0aa1993050f6badc30f6661606.jpg";